import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Switch } from "@mui/material";

// import JS files
import RemoveModal from "../../../shares/RemoveModal";
import CustomerInfoModal from "./CustomerInfoModal";
import useFetch from "../../../../context/useFetch";
import EditCustomer from "./EditCustomer";
import MuiButton from "../../../shares/MuiButton";
import { useUserData } from "../../../../context/UserDataContext";

// import Others files
import sampleImg from "../../../../imgs/customerAvatar.png";

const CustomerCard = (props) => {
  const [id, seId] = useState(props.userId);
  const [userUserName, setUserUserName] = useState();

  const [openInfoCustomerModal, setOpenInfoCustomerModal] = useState(false);
  const handleInfoCustomerModal = () => {
    setOpenInfoCustomerModal((before) => !before);
  };

  const [openRemoveCustomerCard, setOpenRemoveCustomerCard] = useState(false);
  const handleRemoveCustomerModal = () => {
    setOpenRemoveCustomerCard((before) => !before);
  };

  const [openEditCustomerCard, setOpenEditCustomerCard] = useState(false);
  const handleEditCustomerModal = () => {
    setOpenEditCustomerCard((before) => !before);
  };

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm();

  const deleteUserApi = useFetch({
    method: "delete",
    url: `Customer_Service/${id}`,
    trigger: false,
    argFunc: (res) => {
      props.getFunc.reFetch();
      // toast.success("کاربر موردنظر با موفقیت حذف شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [canCreateOrder, setCanCreateOrder] = useState();
  const handle_switch_change = (event) => {
    setCanCreateOrder(event.target.checked);
    // UpdateBangleApi.reFetch();
  };

  return (
    <>
      {openInfoCustomerModal && (
        <CustomerInfoModal
          openModal={openInfoCustomerModal}
          setOpenModal={setOpenInfoCustomerModal}
          name={props.name}
          phone_number={props.phone_number}
          attach_file={props.attach_file}
          store_name={props.store_name}
          address={props.address}
          city={props.city}
          email={props.email}
          phone={props.phone}
          user={props.user}
          userId={props.userId}
        />
      )}

      {openEditCustomerCard && (
        <EditCustomer
          openModal={openEditCustomerCard}
          setOpenModal={setOpenEditCustomerCard}
          name={props.name}
          phone_number={props.phone_number}
          attach_file={props.attach_file}
          store_name={props.store_name}
          address={props.address}
          city={props.city}
          email={props.email}
          phone={props.phone}
          user={props.user}
          userId={props.userId}
          getFunc={props.getFunc}
        />
      )}
      {openRemoveCustomerCard && (
        <RemoveModal
          openModal={openRemoveCustomerCard}
          setOpenModal={setOpenRemoveCustomerCard}
          onClick={() => deleteUserApi.reFetch()}
          text="آیا از حذف مشتری موردنظر اطمینان دارید؟"
        />
      )}
      <div className="panel-card">
        <div className="group flex flex-col items-center justify-center mb-8">
          {props.attach_file == "EMPTY" ? (
            <img
              className="w-20 h-20 md:w-40 md:h-40 rounded-full"
              src={sampleImg}
            />
          ) : (
            <img
              className="w-28 h-28 md:w-40 md:h-40 rounded-full"
              src={props.attach_file}
            />
          )}
        </div>
        <div className="flex items-center justify-between">
          <span className="show-label	">
            نام: <span className="show-value"> {props.name} </span>
          </span>
          <span className="show-label">
            فروشگاه: <span className="show-value">{props.store_name} </span>
          </span>
        </div>

        <div className="flex items-center justify-between mt-6">
          <MuiButton
            onClick={handleInfoCustomerModal}
            variant="outlined"
            // icon={<AddIcon />}
            color="secondary"
            text="اطلاعات بیشتر"
          />

          <div className="flex items-center">
            <span className="text-xs md:text-sm">ثبت سفارش:</span>
            <Switch onChange={handle_switch_change} checked={canCreateOrder} />
          </div>
        </div>
        <div className="flex  justify-between mt-6">
          <div className="edit-icon">
            <EditIcon onClick={() => handleEditCustomerModal()} />
          </div>

          <div
            className="delete-icon"
            onClick={() => handleRemoveCustomerModal()}
          >
            <DeleteIcon />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerCard;
